import * as T from 'io-ts';
const CreateCustomerPortalLinkRequestT = T.type({});
const CreateCustomerPortalLinkOkResponseT = T.type({
    status: T.literal('Ok'),
    url: T.string,
});
const CreateCustomerPortalLinkErrorRespontT = T.type({
    status: T.literal('Error'),
    message: T.string,
});
const CreateCustomerPortalLinkResponseT = T.union([
    CreateCustomerPortalLinkOkResponseT,
    CreateCustomerPortalLinkErrorRespontT,
]);
export { CreateCustomerPortalLinkRequestT, CreateCustomerPortalLinkResponseT };
